import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;
const TOKEN_KEY = "tdf_affiliate_token";

const AffiliateAuthContext = createContext(null);

export function useAffiliateAuth() { return useContext(AffiliateAuthContext); }

export function AffiliateAuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY) || "");
  const [partner, setPartner] = useState(null);
  const [loading, setLoading] = useState(true);

  const apiClient = useCallback(() => {
    return axios.create({
      baseURL: API,
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
  }, [token]);

  useEffect(() => {
    if (!token) { setPartner(null); setLoading(false); return; }
    apiClient().get("/affiliate/me")
      .then((r) => setPartner(r.data))
      .catch(() => { localStorage.removeItem(TOKEN_KEY); setToken(""); setPartner(null); })
      .finally(() => setLoading(false));
  }, [token, apiClient]);

  const login = useCallback(async (email, password) => {
    const res = await axios.post(`${API}/affiliate/login`, { email, password });
    localStorage.setItem(TOKEN_KEY, res.data.token);
    setToken(res.data.token);
    return res.data;
  }, []);

  const setSessionToken = useCallback((newToken) => {
    localStorage.setItem(TOKEN_KEY, newToken);
    setToken(newToken);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    setToken("");
    setPartner(null);
  }, []);

  return (
    <AffiliateAuthContext.Provider value={{ token, partner, loading, login, logout, setSessionToken, apiClient }}>
      {children}
    </AffiliateAuthContext.Provider>
  );
}
